import { DateShortcut, isDateFilter } from "@/SharedComponents/Filters";
import { useDateShortcuts } from "@/Components/Date/DateShortcutsList";

const { shortcuts } = useDateShortcuts();

export function removeDateFilterShortcutRanges(filterStates) {
    return Object.fromEntries(
        Object.entries(filterStates).map(([filterType, filterState]) => {
            const isCustomDate = filterState.shortcutId === DateShortcut.CUSTOM;

            if (!isDateFilter(filterType) || isCustomDate) {
                return [filterType, filterState];
            }

            return [filterType, { shortcutId: filterState.shortcutId }];
        })
    );
}

export function addDateFilterShortcutRanges(filterStates) {
    return Object.fromEntries(
        Object.entries(filterStates).map(([filterType, filterState]) => {
            const isCustomDate = filterState.shortcutId === DateShortcut.CUSTOM;

            if (!isDateFilter(filterType) || isCustomDate) {
                return [filterType, filterState];
            }

            const shortcut = shortcuts.find(
                (shortcut) => shortcut.id === filterState.shortcutId
            );

            return [
                filterType,
                {
                    ...filterState,
                    range: shortcut ? shortcut.range() : [],
                },
            ];
        })
    );
}
